import React, { createContext, useContext, useMemo, useState } from "react"

const EndpointsContext = createContext({ endpoints: {}, setEndpoints: () => {} })

// A quote opened unsaved has no endpoints yet: its first save hands them over.
export const EndpointsProvider = ({ value, children }) => {
  const [endpoints, setEndpoints] = useState(value || {})
  const context = useMemo(() => ({ endpoints, setEndpoints }), [endpoints])

  return (
    <EndpointsContext.Provider value={context}>
      {children}
    </EndpointsContext.Provider>
  )
}

export const useEndpoints    = () => useContext(EndpointsContext).endpoints
export const useSetEndpoints = () => useContext(EndpointsContext).setEndpoints
